import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetInvoiceDetailsQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['bigint']['input'];
}>;


export type GetInvoiceDetailsQuery = { __typename?: 'query_root', arinvoices_by_pk?: { __typename?: 'arinvoices', id: number, invoice_type: string, status: string, accounting_num?: string | null, start_datetime: string, end_datetime: string, customer?: { __typename?: 'customers', id: number, auto_pay: boolean, billing_frequency: string, config?: object | null, effective_config?: object | null, name?: string | null, notify_billing?: boolean | null, payment_terms: number, organization?: { __typename?: 'organizations', id: number, config?: object | null } | null, paymentmethods: Array<{ __typename?: 'arpaymentmethods', id: number }> } | null, armoves: Array<{ __typename?: 'armoves', id: number, accounting_item_id?: string | null, active: number, arevent_id: string, author: string, billable_datetime: string, discount_amount: number, discount_reason?: string | null, dispute_reason?: string | null, disputed: boolean, due_amount: number, invoice_id: number, move_id?: number | null, notes: string, paid_amount: number, status: string, type: string, move?: { __typename?: 'moves', id: number, active: number, class?: string | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_successful?: string | null, pickup_arrived?: string | null, pickup_started?: string | null, pickup_successful?: string | null, reference_num?: string | null, status?: string | null, tags?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_odometer?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, cancel_status?: string | null, customer?: { __typename?: 'customers', id: number, name?: string | null } | null, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null }, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, region?: { __typename?: 'regions', id: number, accounting_class_num?: string | null } | null } } | null, raterule?: { __typename?: 'move_raterule', id?: number | null, rate?: number | null, type?: string | null, class?: string | null } | null, childMoves: Array<{ __typename?: 'moves', id: number, active: number, move_type: string, pickup_time?: string | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_successful?: string | null, pickup_arrived?: string | null, pickup_started?: string | null, pickup_successful?: string | null, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null }, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, region?: { __typename?: 'regions', id: number, accounting_class_num?: string | null } | null } } | null, ridehails: Array<{ __typename?: 'ridehails', id: number, provider?: string | null, external_id?: string | null, product_type?: string | null }> }> } | null, delayDetails: { __typename?: 'armovedetails_aggregate', aggregate?: { __typename?: 'armovedetails_aggregate_fields', count: number, sum?: { __typename?: 'armovedetails_sum_fields', amount?: number | null } | null } | null }, fuelDetails: { __typename?: 'armovedetails_aggregate', aggregate?: { __typename?: 'armovedetails_aggregate_fields', count: number, sum?: { __typename?: 'armovedetails_sum_fields', amount?: number | null } | null } | null }, partialDetails: { __typename?: 'armovedetails_aggregate', aggregate?: { __typename?: 'armovedetails_aggregate_fields', count: number, sum?: { __typename?: 'armovedetails_sum_fields', amount?: number | null } | null } | null }, rideDetails: { __typename?: 'armovedetails_aggregate', aggregate?: { __typename?: 'armovedetails_aggregate_fields', count: number, sum?: { __typename?: 'armovedetails_sum_fields', amount?: number | null } | null } | null }, surgeDetails: { __typename?: 'armovedetails_aggregate', aggregate?: { __typename?: 'armovedetails_aggregate_fields', count: number, sum?: { __typename?: 'armovedetails_sum_fields', amount?: number | null } | null } | null }, towDetails: { __typename?: 'armovedetails_aggregate', aggregate?: { __typename?: 'armovedetails_aggregate_fields', count: number, sum?: { __typename?: 'armovedetails_sum_fields', amount?: number | null } | null } | null }, transportDetails: { __typename?: 'armovedetails_aggregate', aggregate?: { __typename?: 'armovedetails_aggregate_fields', count: number, sum?: { __typename?: 'armovedetails_sum_fields', amount?: number | null } | null } | null }, waivedDetails: { __typename?: 'armovedetails_aggregate', aggregate?: { __typename?: 'armovedetails_aggregate_fields', count: number, sum?: { __typename?: 'armovedetails_sum_fields', amount?: number | null } | null } | null }, details: Array<{ __typename?: 'armovedetails', id: number, armove_id: number, name: string, notes: string, amount: number, rate_source?: string | null, documents: Array<{ __typename?: 'documents', id: number, mime_type: string, name: string, url: string }> }>, revisions: Array<{ __typename?: 'armoveshistory', id: number, revision: number, due_amount: number, discount_amount: number, discount_reason?: string | null, disputed: boolean, dispute_reason?: string | null, details: Array<{ __typename?: 'armovedetailshistory', id: number, name: string, notes: string, amount: number, documents: Array<{ __typename?: 'documents', id: number, mime_type: string, name: string, url: string }> }> }> }>, arpayments: Array<{ __typename?: 'arpayments', id: number, status: string, amount: number, accounting_id?: string | null, gateway_transaction_id?: string | null, createdat?: string | null }> } | null };


export const GetInvoiceDetailsDocument = gql`
    query getInvoiceDetails($invoiceId: bigint!) {
  arinvoices_by_pk(id: $invoiceId) {
    id
    invoice_type
    status
    accounting_num
    start_datetime
    end_datetime
    customer {
      id
      auto_pay
      billing_frequency
      config
      effective_config
      organization {
        id
        config
      }
      name
      notify_billing
      payment_terms
      paymentmethods(where: {type: {_eq: "manual"}}) {
        id
      }
    }
    armoves(where: {active: {_eq: 1}}, order_by: {id: asc}) {
      id
      accounting_item_id
      active
      arevent_id
      author
      billable_datetime
      discount_amount
      discount_reason
      dispute_reason
      disputed
      due_amount
      invoice_id
      move_id
      notes
      paid_amount
      status
      type
      move {
        id
        active
        class
        delivery_arrived
        delivery_started
        delivery_successful
        pickup_arrived
        pickup_started
        pickup_successful
        reference_num
        status
        tags
        vehicle_color
        vehicle_make
        vehicle_model
        vehicle_odometer
        vehicle_stock
        vehicle_vin
        vehicle_year
        cancel_status
        customer {
          id
          name
        }
        lane {
          id
          description
          distance_miles
          delivery {
            id
            name
            address
          }
          pickup {
            id
            name
            address
            region {
              id
              accounting_class_num
            }
          }
        }
        raterule {
          id
          rate
          type
          class
        }
        childMoves(where: {active: {_eq: 1}, move_type: {_eq: "ride"}}) {
          id
          active
          move_type
          pickup_time
          delivery_arrived
          delivery_started
          delivery_successful
          pickup_arrived
          pickup_started
          pickup_successful
          lane {
            id
            description
            distance_miles
            delivery {
              id
              name
              address
            }
            pickup {
              id
              name
              address
              region {
                id
                accounting_class_num
              }
            }
          }
          ridehails(order_by: {created_at: desc}) {
            id
            provider
            external_id
            product_type
          }
        }
      }
      delayDetails: details_aggregate(where: {name: {_eq: "delay"}}) {
        aggregate {
          count
          sum {
            amount
          }
        }
      }
      fuelDetails: details_aggregate(where: {name: {_eq: "fuel"}}) {
        aggregate {
          count
          sum {
            amount
          }
        }
      }
      partialDetails: details_aggregate(where: {name: {_eq: "partial"}}) {
        aggregate {
          count
          sum {
            amount
          }
        }
      }
      rideDetails: details_aggregate(where: {name: {_eq: "ride"}}) {
        aggregate {
          count
          sum {
            amount
          }
        }
      }
      surgeDetails: details_aggregate(where: {name: {_eq: "surge"}}) {
        aggregate {
          count
          sum {
            amount
          }
        }
      }
      towDetails: details_aggregate(where: {name: {_eq: "tow"}}) {
        aggregate {
          count
          sum {
            amount
          }
        }
      }
      transportDetails: details_aggregate(where: {name: {_eq: "Transport"}}) {
        aggregate {
          count
          sum {
            amount
          }
        }
      }
      waivedDetails: details_aggregate(where: {name: {_eq: "waived"}}) {
        aggregate {
          count
          sum {
            amount
          }
        }
      }
      details {
        id
        armove_id
        name
        notes
        amount
        rate_source
        documents {
          id
          mime_type
          name
          url
        }
      }
      revisions(order_by: {revision: desc}) {
        id
        revision
        due_amount
        discount_amount
        discount_reason
        disputed
        dispute_reason
        details {
          id
          name
          notes
          amount
          documents {
            id
            mime_type
            name
            url
          }
        }
      }
    }
    arpayments(order_by: {createdat: asc}) {
      id
      status
      amount
      accounting_id
      gateway_transaction_id
      createdat
    }
  }
}
    `;

/**
 * __useGetInvoiceDetailsQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDetailsQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables> & ({ variables: GetInvoiceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>(GetInvoiceDetailsDocument, options);
      }
export function useGetInvoiceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>(GetInvoiceDetailsDocument, options);
        }
// @ts-ignore
export function useGetInvoiceDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>;
export function useGetInvoiceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceDetailsQuery | undefined, GetInvoiceDetailsQueryVariables>;
export function useGetInvoiceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>(GetInvoiceDetailsDocument, options);
        }
export type GetInvoiceDetailsQueryHookResult = ReturnType<typeof useGetInvoiceDetailsQuery>;
export type GetInvoiceDetailsLazyQueryHookResult = ReturnType<typeof useGetInvoiceDetailsLazyQuery>;
export type GetInvoiceDetailsSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceDetailsSuspenseQuery>;
export type GetInvoiceDetailsQueryResult = Apollo.QueryResult<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/invoices/queries/getInvoiceDetails.query.gql}
 */
export async function getInvoiceDetails(
  variables: GetInvoiceDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetInvoiceDetailsQuery['arinvoices_by_pk']>
export async function getInvoiceDetails(
  variables: GetInvoiceDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetInvoiceDetailsQuery>
export async function getInvoiceDetails(
  variables: GetInvoiceDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetInvoiceDetailsQuery['arinvoices_by_pk'] | GetInvoiceDetailsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetInvoiceDetailsQuery>(
    GetInvoiceDetailsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.arinvoices_by_pk
}